import { Component } from 'react';
import PropTypes from 'prop-types';
import lodash from 'lodash';

import Input from 'components/common/Input/FormInput';
import styles from './RadioList.scss';

class RadioList extends Component {
    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
        this.onOtherChanged = this.onOtherChanged.bind(this);

        this.state = {
            selectedOption: null,
            otherOptionSelected: false,
            otherOptionText: '',
        };
    }

    componentDidMount(){
        const otherOptionSelected = !lodash.isEmpty(this.props.value) && !lodash.includes(this.props.options, this.props.value);
        const selectedOption = otherOptionSelected ? 'Other': this.props.value;
        const otherOptionText = otherOptionSelected ? this.props.value : '';

        this.setState({
            selectedOption,
            otherOptionSelected,
            otherOptionText,
        });
    }

    onChange(event) {
        const value = event.target.value;

        this.setState({
            selectedOption: value,
            otherOptionSelected: value === 'Other',
            otherOptionText: '',
        }, () => {
            this.props.onSelect(value);
        });
    }

    onOtherChanged(event) {
        const value = event.target.value;

        this.setState({
            otherOptionText: value,
        }, () => {
            this.props.onSelect(value);
        });
    }

    createOption(name, option) {
        const inputLabelWrapper = `${name}-option-${option}-wrapper`;
        const optionKey = `${name}-option-${option}`;

        return (
            <div key={inputLabelWrapper} id={inputLabelWrapper} className={styles.inputOption} data-cy="RadioList">
                <input
                    id={optionKey}
                    value={option}
                    checked={option === this.state.selectedOption}
                    onChange={() => {}}
                    type='radio'
                    name={name}
                    data-cy="RadioList-radio"
                />
                <label htmlFor={optionKey} data-cy="RadioList-option">{option}</label>
            </div>
        );
    }

    displayOtherOption(name) {
        const optionKey = `${name}-option-other-input`;

        return (
            <div key={optionKey} onChange={this.onOtherChanged} data-cy="RadioList-displayOtherOption">
                <Input
                    placeholder={'Other'}
                    value={this.state.otherOptionText}
                    autoFocus={true}
                    isValid={() => true}
                    onBlur={() => {}}
                    onChange={() => {}}
                    data-cy="RadioList-Other"
                />
            </div>
        );
    }

    render() {
        const { name, title, options } = this.props;

        const radioOptions = [...options];
        if (!this.props.disableOtherOption) {
            radioOptions.push('Other');
        }

        return (
            <div key={`${name}-container`} className={styles.container} data-cy="RadioList-container">
                <h3 className={styles.title} data-cy="RadioList-title">{title}</h3>

                <div key={`${name}-options`} onChange={this.onChange} data-cy="RadioList-onChange">
                    { radioOptions.map(option => {
                        return this.createOption(name, option);
                    })}
                </div>

                { this.state.otherOptionSelected && (
                    this.displayOtherOption(name)
                )}
            </div>
        );
    }
}

RadioList.propTypes = {
    title: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    onSelect: PropTypes.func.isRequired,
};

export default RadioList;
